module.exports = __webpack_public_path__ + "img/message.98926a58.svg";